import { jsx as _jsx } from "react/jsx-runtime";
import { Children, forwardRef, useEffect, useState } from 'react';
import { Combobox as HeadlessCombobox } from '@flywire/react-headlessui';
import { cx } from '../../utils';
import { useComboboxContext } from './Combobox';
export const useOptionsClasses = ({ className, hasOptions = true }) => {
    return cx('absolute z-10 max-h-64 w-full overflow-y-auto rounded-md empty:hidden', 'text-md bg-white', `${hasOptions ? 'ring-1 shadow-sm' : 'ring-0'} ring-gray-500 disabled:ring-gray-200`, className);
};
const OptionsComponent = forwardRef(({ children, className, ...rest }, ref) => {
    const { inputRef } = useComboboxContext();
    const [inputHeight, setInputHeight] = useState(0);
    const hasOptions = Children.count(children) > 0;
    const classes = useOptionsClasses({ className, hasOptions });
    useEffect(() => {
        if (inputRef.current) {
            setInputHeight(inputRef.current.offsetHeight);
        }
    }, [inputRef]);
    return (_jsx(HeadlessCombobox.Options, { ...rest, className: classes, ref: ref, style: { marginTop: `${inputHeight + 8}px` }, children: children }));
});
OptionsComponent.displayName = 'Options';
const Options = OptionsComponent;
export { Options };
//# sourceMappingURL=Options.js.map